import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert, {AlertProps} from "@material-ui/lab/Alert";
import {makeStyles, Theme} from "@material-ui/core/styles";

import {toastPopupCloseAction} from "../features/sliceReducer/interactionReducer";
import {RootState} from "../features/store";

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    zIndex: 1000,
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function ToastPopup() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {toastPopupToggle, toastPopupContents, severity} = useSelector(
    (state: RootState) => state.interaction
  );
  const {isAuth} = useSelector((state: RootState) => state.auth);

  const handleClose = () => {
    dispatch(toastPopupCloseAction());
  };

  return (
    <div className={classes.root}>
      <Snackbar
        open={toastPopupToggle}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={severity}>
          {toastPopupContents}
        </Alert>
      </Snackbar>
    </div>
  );
}
